<template>
  <div class="wrap">
    <div class="inbox" ref="inboxRef">
      <div class="bg_w">
        <span class="span" style="font-size: 13px;min-width: 70px">{{
            group ? $t('select.user') : $t('common.emailbox.select')
          }}：</span>
        <el-select v-model="selectedTeamSelectValue" @change="handleSelectUser" :placeholder="$t('common.email.chooseEmail')"
                   style="margin-right: 10px;font-size: 13px" size="small">
          <el-option v-if="group" :label="$t('common.all')" :value="allTeamUserOptionLabel" :key="allTeamUserOptionLabel"/>
          <el-option
              v-for="item in tableDataSelect"
              :label="item.userName"
              :value="item.userId"
              :key="item.userId"
          />
        </el-select>
        <el-select v-model="selectedFolder" size="small" @change="handleSelectFolder" v-if="group"
                   :disabled="isGroupSelectionLocked"
                   style="margin-right: 10px;">
          <el-option :label="$t('common.all')" value="all" :key="$t('common.all')"></el-option>
          <el-option
              v-for="item in filteredTargetFileList"
              :label="item.fileName"
              :value="item.id"
              :key="item.id"
          />
        </el-select>
        <el-select v-model="configId" size="small" :disabled="isGroupSelectionLocked">
          <el-option :label="$t('common.setting.allEmail')" value="all" id="all"/>
          <el-option
              v-for="item in emailList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
          />
        </el-select>
        <div style="flex-grow: 1;"></div>
        <el-input
            v-model="searchCount"
            :placeholder="$t('common.search.p')"
            class="input-with-select"
            clearable
            size="small"
            @blur="trimSearchCount"
            @clear="handleSearchInput('clear')"
            @keydown.enter.native="handleSearchInput"
        >
          <template #append>
            <ElButton type="primary" size="small" @click="handleSearchInput('search')"
                      style="font-size: 13px !important;">
              {{ $t('common.search') }}
            </ElButton>
          </template>
        </el-input>
        <el-button style="margin-left: 10px;font-size: 13px !important;" @click="drawer = true" size="small">
          {{ $t('common.search.advanced') }}
        </el-button>
      </div>
      <div class="screen">
        <div class="screen_btn">
          <template v-if="type === 1 || type === 3">
            <ElButton size="small" @click="requestTagAllRead">{{ $t('common.read.all') }}</ElButton>
            <ElButton size="small" @click="handleBatchSetRead">{{ $t('common.read.set') }}</ElButton>
            <ElButton size="small" @click="handleBatchDelete">{{ $t('common.delete') }}</ElButton>
            <!-- <ElButton size="small" v-if="type === 1">垃圾邮件</ElButton> -->
          </template>
          <ElButton size="small" v-if="type === 2" @click="handleDraftDelete">{{
              $t('common.draft.delete')
            }}
          </ElButton>
          <ElButton size="small" v-if="type === 1" @click="handleBlack">{{ $t('common.block') }}</ElButton>
          <template v-if="type === 4">
            <ElButton size="small" @click="requestTagAllRead">{{ $t('common.read.all') }}</ElButton>
            <ElButton size="small" @click="handleTrashEmpty">{{ $t('common.delete.empty') }}</ElButton>
            <ElButton size="small" @click="handleBlack">{{ $t('common.block') }}</ElButton>
            <ElButton size="small" @click="handleTrashRestore">{{ $t('common.restore') }}</ElButton>
          </template>
          <ElDropdown size="small" @command="handleCommand">
            <el-button size="small">
              {{ $t('common.mark.to') }}&nbsp;<el-icon><ArrowDown /></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="0">{{ $t('common.email.read') }}</el-dropdown-item>
                <el-dropdown-item :command="1">{{ $t('common.email.noread') }}</el-dropdown-item>
                <el-dropdown-item :command="2">{{ $t('common.email.starmark') }}</el-dropdown-item>
                <el-dropdown-item :command="3">{{ $t('common.cancel.mark') }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </ElDropdown>
          <ElDropdown size="small" @command="handleGroupEmail"
                      v-if="(type===1||type===3)&&moveTargetFileList.length>0">
            <el-button size="small">
              {{ $t('common.move.to') }}&nbsp;<el-icon><ArrowDown /></el-icon>
            </el-button>
            <template #dropdown>
              <div @scroll="handleScroll" class="dropdown-menu-wrapper"
                   style="max-height: 300px;max-width: 180px; overflow-y: auto;">
                <el-dropdown-menu class="move-select">
                  <el-dropdown-item :command="item.id"
                                    v-for="item in filteredMoveTargetFileList"
                                    :key="item.id">
                    <template v-if="item.isSystemTarget">
                      <span style="color: #5e9ff8">{{ item.fileName }}</span>
                    </template>
                    <template v-else>
                      {{ item.fileName }}
                    </template>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </div>
            </template>
          </ElDropdown>
          <el-button size="small" v-else-if="(type===1||type===3)">
            {{ $t('common.move.to') }}&nbsp;<el-icon><ArrowDown /></el-icon>
          </el-button>
        </div>
        <el-pagination
            v-model:current-page="current"
            v-model:page-size="size"
            small="small"
            v-if="total"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
        />
      </div>
      <!--      新的移动模块-->
      <div class="Drag2" ref="DragBox">
        <div class="box" ref="box">
          <!--      <div class="left">-->
          <!--        &lt;!&ndash;左侧div内容&ndash;&gt;-->
          <!--      </div>-->
          <!--      <div class="resize" title="左右侧边栏">⋮</div>-->
          <div class="mid">
            <!--右侧div内容-->
            <div class="topBox" :style="{height: topPanelHeight + 'px'}">
              <!--右上div内容-->
              <ElTable v-loading="loading"
                       :data="tableData"
                       row-key="id"
                       @selection-change="handleSelectionChange"
                       size="small"
                       highlight-current-row
                       ref="tableRef"
                       id="sp_tables"
                       style="width: 100vw"
                       height="100%"
                       @current-change="handleCurrentRowChange"
                       :row-class-name="tableRowClassName"
                       @sort-change="sort_change"
                       :cell-style="rowClassName"
                       :header-cell-style="headerClassName"
                       :row-style="tableRowStyle"
                       @cell-mouse-enter="mouseEnters"
                       @cell-mouse-leave="mouseLeaves"
                       @row-dblclick="handleViewDetail"
              >
                <el-table-column type="selection" :reserve-selection="true" width="30" fixed="left"/>
                <el-table-column width="20" prop="isStress" sortable="custom"
                                 class-name="sort_ps"
                >
                  <template #header>
                    <img style="position: absolute;left: 1px;top: 9px;" src="../../../assets/email/hp.svg"/>
                  </template>
                  <template #default="scope">
                    <img v-if="scope.row.isStress === 1" @click.stop="handleSettingStress(scope, 3)"
                         class="pointer flags_f"
                         src="../../../assets/email/hp.svg"/>
                    <img v-else class="pointer flags_f" @click.stop="handleSettingStress(scope, 2)"
                         src="../../../assets/email/hp1.svg"/>
                  </template>
                </el-table-column>
                <el-table-column width="30" prop="isRead" sortable="custom" class-name="sort_ps">
                  <template #header>
                    <img style="position: absolute;left: 8px;top: 9px;" src="../../../assets/email/weidu.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 8px;top: 6px" v-if="scope.row.isRead === 1"
                         @click.stop="handleSetRead(scope)" class="pointer"
                         src="../../../assets/email/yidu.svg"/>
                    <img style="position: absolute;left: 8px;top:9px" v-else class="pointer"
                         @click.stop="handleSetRead(scope)"
                         src="../../../assets/email/weidu.svg"/>
                  </template>
                </el-table-column>
                <el-table-column width="20" prop="fj" sortable="custom" class-name="sort_ps">
                  <template #header>
                    <img style="position: absolute;left: 6px;top:9px" src="../../../assets/email/fj.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 6px;top:9px" v-if="scope.row.isExtend === 1" class="pointer"
                         src="../../../assets/email/fj.svg"
                         @click.stop="handleDownload(scope)"/>
                  </template>
                </el-table-column>
                <el-table-column width="30" prop="reply" sortable="custom" class-name="sort_ps"
                                 v-if="type===1||type===3">
                  <template #default="{row}">
                    <img v-if="row.isReply===1&&type===1" style="position: absolute;left:6px;top:8px" height="14"
                         src="../../../assets/email/rp2.png">
                    <img v-else-if="row.isAnswer===1&&type===3" style="position: absolute;left:6px;top:8px" height="14"
                         src="../../../assets/email/rp1.png">
                  </template>
                </el-table-column>
                <el-table-column
                    prop="from"
                    :label="type !== 1 && type !== 4 ? $t('common.email.to') : $t('common.email.from')"
                    width="265"
                >
                  <template #default="scope">
                    <!-- 类型为 1 或 4 -->
                    <template v-if="type === 1 || type === 4">
                      <el-popover
                          v-if="(scope.row.customerName != null || scope.row.contactEmail != null) && scope.row.onclick"
                          :width="'max-content'"
                          effect="dark"
                          trigger="hover"
                          :show-after="1200"
                          :content="scope.row.contactEmail != null ? scope.row.contactEmail : scope.row.customerName + '(' + scope.row.companyEmail + ')'"
                      >
                        <template #reference>
                          <div v-if="scope.row.customerName != null"
                               @click="handleClickToLinkCustomerDetail(scope.row.customerId, scope.row.type)">
                            <OverflowTooltip
                                :content="scope.row.customerName"
                                :show-after="1200"
                                style="color: var(--el-color-primary); max-width: 100%;"
                            >
                              <span style="color: var(--el-color-primary)"
                                    v-html="highlightKeyword(scope.row.customerName, searchCount)"></span>
                            </OverflowTooltip>
                          </div>
                          <span v-else>
                        <OverflowTooltip
                            :content="scope.row.from"
                            :show-after="1200"
                        >
                          <span
                              v-html="highlightKeyword(
                              scope.row.flag === 1
                                ? scope.row.from
                                : scope.row.customerName != null
                                ? scope.row.customerName
                                : scope.row.contactName != null
                                ? scope.row.contactName
                                : scope.row.from,
                              searchCount
                            )"
                          ></span>
                        </OverflowTooltip>
                       </span>
                        </template>
                      </el-popover>
                      <span v-else>
                      <OverflowTooltip
                          :content="scope.row.from"
                          :show-after="1200"
                      >
                        <span
                            v-html="highlightKeyword(
                            scope.row.flag === 1
                              ? scope.row.from
                              : scope.row.customerName != null
                              ? scope.row.customerName
                              : scope.row.contactName != null
                              ? scope.row.contactName
                              : scope.row.from,
                            searchCount
                          )"
                        ></span>
                      </OverflowTooltip>
                    </span>
                    </template>
                    <!-- 非 type 1 和 4 -->
                    <template v-else>
                      <el-popover
                          v-if="scope.row.customerName !== null && scope.row.onclick"
                          placement="right"
                          :width="'max-content'"
                          effect="dark"
                          trigger="hover"
                          :show-after="1200"
                          :content="scope.row.contactEmail != null ? scope.row.contactEmail : scope.row.customerName + '(' + scope.row.companyEmail + ')'"
                      >
                        <template #reference>
                          <div @click="handleClickToLinkCustomerDetail(scope.row.customerId, scope.row.type)">
                            <OverflowTooltip
                                :content="scope.row.customerName"
                                :show-after="1200"
                                style="color: var(--el-color-primary); max-width: 100%;"
                            >
                              <span style="color: var(--el-color-primary);"
                                    v-html="highlightKeyword(scope.row.customerName, searchCount)"></span>
                            </OverflowTooltip>
                          </div>
                        </template>
                      </el-popover>
                      <template v-else>
                        <template v-if="scope.row.mailRecipientList && scope.row.mailRecipientList.length > 1">
                          <el-popover
                              placement="right"
                              :width="'max-content'"
                              effect="dark"
                              trigger="hover"
                              :show-after="1200"
                              :content="scope.row.mailRecipientList.join(' , ')"
                          >
                            <template #reference>
                              <OverflowTooltip
                                  :content="scope.row.mailRecipientList[0] + '...'"
                                  :show-after="1200"
                              >
                                <span
                                    v-html="highlightKeyword(`${scope.row.mailRecipientList[0]} ...`, searchCount)"></span>
                              </OverflowTooltip>
                            </template>
                          </el-popover>
                        </template>
                        <template v-else>
                          <OverflowTooltip
                              :content="scope.row.customerName || (scope.row.mailRecipientList ? scope.row.mailRecipientList[0] : '')"
                              :show-after="1200"
                          >
                              <span
                                  v-html="highlightKeyword(
                                  scope.row.customerName
                                    ? scope.row.customerName
                                    : scope.row.mailRecipientList
                                    ? scope.row.mailRecipientList[0]
                                    : '',
                                  searchCount
                                )"
                              ></span>
                          </OverflowTooltip>
                        </template>
                      </template>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column width="18">
                  <template #default="scope">
                    <img
                        v-if="scope.row.urgent === 1"
                        src="../../../assets/svg/warning.svg"
                        class="urgent-icon"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="subject" :label="$t('common.subject')">
                  <template #default="scope">
                    <!-- 紧急图标 -->
                    <div
                        class="subject-cell"
                        style="display: flex; align-items: center; position: relative;"
                    >
                      <!-- 内容部分，是否溢出决定是否显示 tooltip -->
                      <OverflowTooltip
                          :content="scope.row.subject"
                          :show-after="1200"
                      >
                        <a
                            @click.stop="handleViewDetail(scope.row)"
                            class="subject-text"
                        >
                          <span
                              v-html="highlightKeyword(scope.row.subject, searchCount)"></span>
                        </a>
                      </OverflowTooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="sendTime"
                    class-name="sort_ps"
                    sortable="custom" :label="$t('common.date')"
                    width="140">
                  <template #default="{row}">
                    <span v-if="row.sendTime!=null">{{ row.sendTime }}</span>
                    <span v-else-if="row.sentDate!==null">{{ row.sentDate }}</span>
                    <span v-else>{{ row.createTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" width="80">
                  <template #default="scope">
                    <div class="flex">
                      <!--                         @click.stop="handleRef(refMap[`${scope.row.id}`], scope.row, 1)"-->
                      <el-icon :ref="(el) => (refMap[`${scope.row.id}`] = el)"
                               @click.stop="handleClickRemark(scope.row)"
                               :color="scope.row.remark ? '#409eff' : '#dddddd'" style="padding-top: -2px">
                        <el-tooltip
                            v-if="emailListCheckoutTarget.remark"
                            class="box-item"
                            :content="emailListCheckoutTarget.remark"
                            placement="right"
                            :show-after="1200"
                        >
                          <Memo/>
                        </el-tooltip>
                        <Memo v-else/>
                      </el-icon>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="type===3" prop="isAnswer" :label="$t('common.email.list.isAnswer')"
                                 :width="flexWidth('isAnswer', tableData, $t('common.email.list.isAnswer'))+10">
                  <template #default="{row}">
                    <template v-if="row.isAnswer ===1">
                      <el-button class="btn_reset" link type="success" size="small">{{ $t('common.email.status1') }}
                      </el-button>
                    </template>
                    <template v-else-if="row.isAnswer===0">
                      <el-button class="btn_reset" link type="warning" size="small">{{ $t('common.email.status2') }}
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column v-if="type===3" prop="isTrack" :label="$t('common.isreading')"
                                 :width="flexWidth('isTrack', tableData, $t('common.isreading'))">
                  <template #default="{row}">
                    <template v-if="row.isTrack===1">
                      <div :ref="(el) => (refMap[`${row.id}_isTrack`] = el)"
                           class="flex">
                        <img
                            @mouseover="handleRef(refMap[`${row.id}_isTrack`], row, 2)" style="cursor: pointer"
                            src="../../../assets/img/email/quanbuyidu.png" height="15"/>
                      </div>
                    </template>
                    <template v-else-if="row.isTrack===0"></template>
                  </template>
                </el-table-column>
                <el-table-column prop="originalPosition" :label="$t('common.location')" v-if="type === 4"
                                 :width="lang!=='zh-CN'?140:80">
                  <template #default="{row}">
                    {{
                      row.originalPosition === 1 ? $t('common.emailbox.receive') : row.originalPosition === 3 ? $t('common.has.sent') : row.originalPosition === 2 ? $t('common.draftsbox') : row.originalPosition === 4 ? $t('common.dustbin') : ''
                    }}
                  </template>
                </el-table-column>
                <!--          已发送-->
                <el-table-column prop="groupId" :label="$t('common.send.state')"
                                 :width="flexWidth('groupId', tableData, $t('common.isreading'))+(lang!=='zh-CN'?80:20)"
                                 v-if="type===3">
                  <template #default="{row}">
                    <template v-if="row.groupId==='3'">
                      <el-button class="btn_reset" link type="success" style="font-size: 13px !important;">
                        {{ $t('common.email.list.sendSuccess') }}
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
                <!--          草稿箱-->
                <el-table-column prop="groupId" :label="$t('common.send.state')" v-else-if="type===2"
                                 :width="flexWidth('groupId', tableData, $t('common.isreading'))+(lang!=='zh-CN'?80:30)">
                  <template #default="{row}">
                    <div v-if="row.groupId==='-1'"
                         style="display: flex;align-items: center;position: relative;justify-content: center">
                      <el-button class="btn_reset" link type="danger" style="font-size: 13px !important;"
                      >
                        {{ $t('common.email.list.sendFailed') }}
                      </el-button>
                      <el-popover
                          class="box-item"
                          :content="showLogError"
                          :effect="'dark'"
                          :show-after="1200"
                          placement="right"
                          @show="handleShowPopover(row)"
                      >
                        <template #reference>
                          <el-icon style="color:var(--el-color-danger);font-size: 16px;position: absolute;right:-5px;">
                            <Warning/>
                          </el-icon>
                        </template>
                      </el-popover>
                    </div>
                    <template v-else-if="row.groupId==='2'">
                      <template v-if="row.sendTime !== null">
                        <el-button class="btn_reset" v-if="new Date(row.sendTime).getTime() > new Date().getTime()" link
                                   type="warning" style="font-size: 13px !important;">{{ $t('common.wait.sent') }}
                        </el-button>
                        <template v-else>
                          <el-button class="btn_reset" link type="info" style="font-size: 13px !important;">
                            {{ $t('common.email.list.draft') }}
                          </el-button>
                        </template>
                      </template>
                      <template v-else>
                        <el-button class="btn_reset" link type="info" style="font-size: 13px !important;">
                          {{ $t('common.email.list.draft') }}
                        </el-button>
                      </template>
                    </template>
                    <template v-else-if="row.groupId==='5'">
                      <el-button class="btn_reset" link
                                 type="warning" style="font-size: 13px !important;">
                        {{ $t('common.wait.sent') }}
                      </el-button>
                    </template>
                    <template v-else-if="row.groupId==='9'">
                      <el-button class="btn_reset" link
                                 type="primary" style="font-size: 13px !important;">
                        {{ $t('common.examine.wait') }}
                      </el-button>
                    </template>
                    <template v-else-if="row.groupId==='10'">
                      <el-button class="btn_reset" link
                                 type="info" style="font-size: 13px !important;">
                        {{ $t('common.email.list.draft.auto') }}
                      </el-button>
                    </template>
                    <template v-else>
                      {{ $t('common.unknown') }}
                    </template>
                  </template>
                </el-table-column>
                <el-table-column prop="settings" fixed="right" :label="$t('common.cz')" :width="computedTargetWidth">
                  <template #default="scope">
                    <template v-if="type !== 4">
                      <el-button link v-if="type===3||type===2" type="primary" size="small"
                                 @click.stop="handleResend(scope.row)"
                      >{{ $t('common.resend') }}
                      </el-button
                      >
                      <el-button link v-if="type===1" type="primary" size="small"
                                 @click.stop="handleReply(scope.row)"
                      >{{ $t('common.reply') }}
                      </el-button
                      >
                      <el-button link v-if="type===1||type===3" type="primary" size="small"
                                 @click.stop="handleReplyDetail('forward',scope.row)"
                      >{{ $t('common.email.forward') }}
                      </el-button
                      >
                      <el-button link type="primary" size="small" @click.stop="handleEdit(scope.row)"
                                 v-if="scope.row.flag===1 && type===1 ||  scope.row.flag===1 && type===3">
                        {{ $t('common.archives.return') }}
                      </el-button>
                    </template>
                    <template v-else>
                      <el-button link type="primary" size="small" @click.stop="requestDelMail(0,scope.row)"
                      >{{ $t('common.restore') }}
                      </el-button
                      >
                      <el-button link type="danger" size="small" @click.stop="requestDelMail(2,scope.row)"
                      >
                        {{ $t('common.delete') }}
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
                <template #empty>
                  <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
                </template>
              </ElTable>
            </div>
            <div
                :title="$t('common.email.dragResizePanels')"
                class="mover"
            >
              <div class="mail_info" ref="moveTarget">
                <div
                    :title="$t('common.email.dragResizePanels')"
                    class="up_row move"
                    @pointerdown.prevent="handleVerticalResizeStart"
                ></div>
                <div style="width: 100%;height: 26px;display: flex">
                  <div class="from over_text">
                    {{ $t('common.email.from') }}：{{ currentMail.mailBody?.from }}
                  </div>
                  <div class="to over_text" ref="toRef">
                    <el-popover
                        v-if="currentMailToText"
                        :visible="visibleTo"
                        width="500"
                        :content="currentMailToText"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                    <span @mouseenter="showPopover(currentMailToText,'to')"
                          @mouseleave="delayedHidePopover('to')">{{
                        $t('common.email.to')
                      }}：{{ currentMailToText }}</span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('to')" @mouseleave="hidePopover('to')">
                        {{ currentMailToText }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.email.to') }}：{{ currentMailToText }}
                    </template>
                  </div>
                  <div class="cc over_text">
                    <el-popover
                        v-if="currentMailCcText"
                        :visible="visibleCC"
                        width="500"
                        :content="currentMailCcText"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                <span
                    @mouseenter="showPopover(currentMailCcText,'cc')"
                    @mouseleave="delayedHidePopover('cc')"
                >
                {{ $t('common.cc') }}：{{ currentMailCcText }}
                </span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('cc')" @mouseleave="hidePopover('cc')">
                        {{ currentMailCcText }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.cc') }}：{{ currentMailCcText }}
                    </template>
                  </div>
                </div>
                <div
                    :title="$t('common.email.dragResizePanels')"
                    class="down_row move"
                    @pointerdown.prevent="handleVerticalResizeStart"
                ></div>
              </div>
            </div>
            <div class="downBox" :style="{height: downPanelHeight + 'px'}">
              <div class="mail-preview-wrapper">
                <div v-loading="detailLoading" class="mail-preview-frame">
                  <iframe ref="pageframe" id="pageframe" :srcdoc="iframeContent"
                          frameborder="0"
                          @load="handleIframeLoad"
                          :style="{width: '100%',height: '100%',pointerEvents: isDragging ? 'none' : 'auto'}"
                          :class="detailLoading?'scroll':'scroll loaded'"
                  ></iframe>
                  <div v-if="isDragging" id="mask"
                       :style="{position:'absolute',inset:'0',background:'rgba(0,0,0,0)',zIndex:999}">
                  </div>
                </div>
                <div v-if="showAttachmentPanel && attachmentList.length" class="attachment-panel">
                  <div class="attachment-panel-body">
                    <div
                        v-for="(item, index) in attachmentList"
                        :key="item.fileId || item.id || item.url || item.name || index"
                        class="file file-item"
                    >
                      <div class="attachment-item-main">
                        <FileIcon
                            :fileExtend="getAttachmentExt(item)"
                            :fileUrl="item.url"
                            :size="24"
                            :isAbbreviation="true"
                        />
                        <el-popover
                            placement="left"
                            :width="'max-content'"
                            effect="dark"
                            trigger="hover"
                            :content="item.name"
                            :show-after="1200"
                        >
                          <template #reference>
                            <a class="name contents text" @click.prevent="handleAttachmentDownload(item.url, item.name)">
                              {{ item.name }}
                            </a>
                          </template>
                        </el-popover>
                      </div>
                      <div class="attachment-item-meta">
                        {{ formatSize(item.extendSize) || '-' }}
                      </div>
                      <div class="attachment-item-actions">
                        <el-button link type="primary" size="small" @click="handleAttachmentDownload(item.url, item.name)">
                          {{ $t('common.download') }}
                        </el-button>
                        <el-button
                            v-if="canPreviewAttachment(item)"
                            link
                            type="primary"
                            size="small"
                            @click="handleDetailFile(item)"
                        >
                          {{ $t('common.preview') }}
                        </el-button>
                        <el-button link type="primary" size="small" @click="handleReSave(item)">
                          {{ $t('common.cloud.Rollover') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--      高级搜索-->
      <el-drawer
          v-model="drawer"
          :title="$t('common.search.advanced')"
          :direction="direction"
          class="el_modal"
          style="padding: 12px"
          @open="handleAdvancedSearchOpen"
      >
        <el-form
            :label-position="labelPosition"
            label-width="100px"
            :model="formLabelAlign"
        >
          <el-form-item :label="$t('common.customer.nameList')+':'" prop="customerId">
            <CustomerSelect
                v-model="formLabelAlign.customerId"
                :teamId="teamId"
                :loading="customerSearchLoading"
                :selected-label="formLabelAlign.customerName"
                :auto-load-on-team-change="false"
                :load-on-visible="false"
                :active="drawer"
                ref="customerSearchRef"
                style="width: 100%;"
                clearable
                @change="handleCustomerSearchChange"
                @loaded="handleCustomerSearchLoaded"
                @loading="handleCustomerSearchLoading"
                :placeholder="$t('select.customer.name')"
            />
          </el-form-item>
          <el-form-item :label="$t('common.customer.levelList')+':'" prop="customerTypeId">
            <el-select
            size="small"
                v-model="formLabelAlign.customerTypeId"
                style="width: 100%;"
                popper-class="customer-level"
                :placeholder="$t('common.please.select')"
            >
              <el-option
                  v-for="item in tableDataLevel"
                  :key="item.id"
                  :label="item.customerType"
                  :value="item.id"
              >
                <div class="inner_select">
                  {{ item.customerType }}
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('common.customer.Region')+':'" prop="zoneAddress">
            <el-select
            size="small"
                filterable
                v-model="formLabelAlign.zoneAddress"
                style="width: 100%;"
                :placeholder="$t('common.please.select')"
            >
              <el-option
                  v-for="item in areaList"
                  :key="item.country"
                  :label="lang!=='zh-CN'?item.countryEn:item.country"
                  :value="lang!=='zh-CN'?item.countryEn:item.country"
              />
            </el-select>
          </el-form-item>
          <!--          发件箱-->
          <!--          <el-form-item :label="$t('reply.status')+':'" prop="isAnswer" v-if="type===3">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.isAnswer"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="$t('common.all')" :value="-1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status1')" :value="1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status2')" :value="0"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          收件箱-->
          <!--          <el-form-item :label="$t('reply.status')+':'" prop="isReply" v-if="type===1">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.isReply"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="$t('common.all')" :value="-1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status1')" :value="1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status2')" :value="0"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item :label="$t('read.status')+':'" prop="isTrack" v-if="type===3">
            <el-select
            size="small"
                filterable
                v-model="formLabelAlign.isTrack"
                style="width: 100%;"
                :placeholder="$t('common.please.select')"
            >
              <el-option :label="$t('common.all')" :value="-1"></el-option>
              <el-option :label="$t('read.status.isread')" :value="1"></el-option>
              <el-option :label="$t('read.status.unread')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item :label="$t('common.send.state')" v-if="type===2">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.type"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="$t('common.setting.allTime')" :value="2"></el-option>-->
          <!--              <el-option :label="$t('common.wait.sent')" :value="5"></el-option>-->
          <!--              <el-option :label="$t('common.email.list.sendFailed')" :value="-1"></el-option>-->
          <!--              <el-option :label="$t('common.examine.wait')" :value="9"></el-option>-->
          <!--              <el-option :label="$t('common.option.select.base.draft')" :value="10"></el-option>-->
          <!--              <el-option :label="$t('common.option.select.base.auto.draft')" :value="12"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item :label="$t('common.date')+':'" prop="rangePickerTime">
            <el-date-picker
            size="small"
                style="width: 100%;"
                v-model="formLabelAlign.rangePickerTime"
                type="daterange"
                format="YYYY-MM-DD HH:mm:ss"
                range-separator="~"
                :start-placeholder="$t('search.start.date')"
                :end-placeholder="$t('search.end.date')"
            />
          </el-form-item>
          <!--          <el-form-item :label="$t('email.list.draft.status')+':'" prop="draftStatus" v-if="type===2">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.isReply"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="'草稿'" :value="1"></el-option>-->
          <!--              <el-option :label="'自动草稿'" :value="0"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          邮件主题、内容-->
          <el-form-item :label="$t('sending.table.col.title')+':'" prop="email">
            <el-input size="small" v-model="formLabelAlign.subject" :placeholder="$t('common.please.input')"/>
          </el-form-item>
          <el-form-item :label="$t('common.height.search.content')+':'" prop="content">
            <el-input size="small" v-model="formLabelAlign.content" :placeholder="$t('common.please.input')"/>
          </el-form-item>
          <el-form-item>
            <div class="fx-j-e" style="margin-top: 10px">
              <el-button size="small" type="primary" style="margin-right: 12px;font-size: 13px;" @click="handleSearch('search')">{{
                  $t('common.search')
                }}
              </el-button>
              <el-button size="small" style="margin-left: 10px;font-size: 13px;" @click="filterReset">{{
                  $t('common.empty')
                }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-drawer>
      <!--      建档-->
      <ReturnEmails ref="emailsReturn" v-if="dialogVisible" v-model="dialogVisible" @close="close"
                    @createCustomer="createdNewCustomer" :targetEmail="activeItemRow" :reGetList="getMailList"
      ></ReturnEmails>
      <!--      创建客户-->
      <CustomerCreated ref="customerCreated" v-if="dialogVisibleCreatedMessage"
                       v-model="dialogVisibleCreatedMessage" @close="closeCreated" :innerDialog="dialogVisible"
                       @changeInnerDialog="close"></CustomerCreated>
      <BlackConfirmModal :showFlag="blackModalShow" :list="blackModalList"
                         @succ="handleBlackSucc" @cancel="handleBlackCancel"/>
      <MoveTargetFile
          v-if="moveTargetFileVisitable"
          v-model="moveTargetFileVisitable"
          @close="closeMoveTarget"
          :is-head-line="true"
          :type="2"
          :activeItem="activeItem"
          :list="refreshCurrentMailDetail"
          :numberFlag="'2'"
          :mail="true"
      ></MoveTargetFile>
      <!--      彻底删除-->
      <Dialog
          v-model="dialogVisibleDelete"
          :title="$t('sys.team.info')"
          :dialogVisible="dialogVisibleDelete"
          :isHeadLine="false"
          :width="420"
          @update:dialogVisible="handleDeleteDialogVisibleUpdate"
          align-center
      >
        <template #content>
          <div class="inners_warning">
            <div><img
                src="data:image/png;base64,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"/>
            </div>
            <div style="font-size: 13px;margin: 20px 0px">
              {{ $t('other.text.ask.email.delete.empty') }}
            </div>
          </div>
        </template>
        <template #footer>
          <div class="setting_center">
            <el-button size="small" style="margin-right: 20px" @click.stop="handleDeleteCancel">
              {{
                $t('common.sss16')
              }}
            </el-button>
            <el-button size="small" type="primary" @click="deleteAll" :loading="deleteLoading">{{ $t('common.confirm') }}</el-button>
          </div>
        </template>
      </Dialog>
      <!--组件抽离-->
      <el-popover
          v-if="popoverType!==0"
          virtual-triggering
          :virtual-ref="tempRef"
          v-model:visible="visiblePopover"
          :placement="popoverType===1?'top':'bottom'"
          :width="popoverType===1?204:popoverType===2?340:300"
          :show-after="1200"
          popper-class="sp_model_popover"
          :effect="popoverType!==1?'dark':'light'"
          :popper-options="{
              modifiers: [{
		          name: 'offset',
		          options: {
			          offset: [8, 8]
		          }
	        }]
	    }">
        <template v-if="popoverType===2">
          <el-tooltip placement="top" style="pointer-events: none">
            <div slot="content" style="pointer-events: none; white-space: pre-line">
              {{
                $t("common.email.list.isTrack", {
                  openTime: emailListCheckoutTarget.openTime,
                  openAddress: emailListCheckoutTarget.openAddress,
                  openIp: emailListCheckoutTarget.openIp,
                  openCount: emailListCheckoutTarget.openCount,
                })
              }}
            </div>
          </el-tooltip>
        </template>
        <template v-else-if="popoverType===3">
          {{ emailListCheckoutTarget.subject }}
        </template>
      </el-popover>
      <!--   添加备注   -->
      <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
              :currentItem="currentItem" @getList="getMailList"></Remark>
    </div>
  </div>
</template>
<script>
import {defineAsyncComponent, onMounted, reactive, ref, watch, provide, computed, nextTick, onBeforeUnmount} from 'vue';
import {
  getMail,
  tagMail,
  tagAllRead,
  delMail,
  getMailByUserId,
  getMailDetails, getGroupMailList, groupEmail
} from '@/api';
import {
  getEmailLog,
  requestMailAccessory,
} from '@/api/mail';
import {getTeamUserListAll} from '@/api/groups';
import {ElMessage, ElTable} from 'element-plus';
import {useStore} from 'vuex';
import {useRoute, useRouter} from "vue-router";
import Dialog from "@/components/Dialog.vue";
import {debouncePlus, throttle} from "@/utils/mylodash"
import {i18n} from "@/lang";
import {emptyUrl, POPOVER_DELAY_TIME} from '@/utils/statusParams'
import {formatSize} from "@/utils/file";
import {flexWidth} from "@/utils/tableWidth";
import {addImgOnErrorAttribute, bindIframeLinkClickToNewTab, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import {getPosType} from "@/utils/device";
import {highlightKeyword} from '@/utils/util.js'
import OverflowTooltip from "@/components/OverflowTooltip/index.vue"
import {replaceEmptyPTagsWithBr, resetCss} from "@/utils/TinyMCE";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";
import CustomerSelect from "@/components/CustomerSelect.vue";
import FileIcon from "@/components/File/FileIcon.vue";
import MoveTargetFile from "@/views/Cloud/Components/MoveTargetFile.vue";
import {
  audioFormat,
  downloadFile,
  excelFormat,
  imgFormat,
  pdfFormat,
  pptFormat,
  textFormat,
  videoFormat,
  wordFormat
} from "@/utils/file";
import {api as viewerApi} from "v-viewer";

function numStr(num) {
  return num < 10 ? `0${num}` : num;
}

function formatTime(date) {
  return `${date.getFullYear()}-${numStr(date.getMonth() + 1)}-${numStr(date.getDate())}`;
}

const commandList = [1, 0, 1, 0];
const tableRowStyle = Object.freeze({height: '30px'});
const cellLeftColumnsMap = {
  1: [0, 1, 3, 4, 5, 6, 10],
  2: [0, 3, 4, 5, 11],
  3: [0, 3, 4, 5, 6, 13],
  4: [0, 3, 4, 5, 6, 10]
};
const headerLeftColumnsMap = {
  1: [0, 1, 3, 4, 5, 6, 7, 10],
  2: [0, 3, 4, 5, 6, 11],
  3: [0, 3, 4, 5, 6, 7, 13],
  4: [0, 3, 4, 5, 6, 10]
};
const cellAlignLeftStyle = Object.freeze({textAlign: 'left'});
const cellAlignCenterStyle = Object.freeze({textAlign: 'center'});
const headerAlignLeftStyle = Object.freeze({'text-align': 'left'});
const headerAlignCenterStyle = Object.freeze({'text-align': 'center'});

const initForm = {
  customerName: null,
  customerId: null,
  customerTypeId: null,
  zoneAddress: null,
  isAnswer: null,
  isTrack: null,
  isReply: null,
  type: 2,
  rangePickerTime: [],
  email: '',
  content: ''
}
const ReturnEmails = defineAsyncComponent(() => import("@/components/DiaPops/Returns/ReturnEmails.vue"));
const CustomerCreated = defineAsyncComponent(() => import("@/components/DiaPops/Returns/CustomerCreated.vue"));
const Remark = defineAsyncComponent(() => import("@/components/Remark/index.vue"));
const BlackConfirmModal = defineAsyncComponent(() => import('../BlackConfirmModal.vue'));

function buildRecipientTextMap(list) {
  if (!list || !list.length) {
    return {to: '', cc: ''};
  }
  const infoMap = {};
  list.forEach((item) => {
    if (!infoMap[item.mailType]) {
      infoMap[item.mailType] = [];
    }
    infoMap[item.mailType].push(item.mail);
  });
  return {
    to: infoMap.to ? infoMap.to.join(' , ') : '',
    cc: infoMap.cc ? infoMap.cc.join(' , ') : '',
  };
}

export default {
  methods: {
    highlightKeyword,
    getPosType,
    flexWidth,
    formatSize
  },
  components: {
    MoveTargetFile,
    FileIcon,
    Remark,
    OverflowTooltip,
    ElTable,
    CustomerSelect,
    CustomerCreated,
    ReturnEmails,
    Dialog,
    BlackConfirmModal,
  },
  // (-1:失败邮件,1:收件箱,2:草稿箱,3:已发送,4:垃圾箱,4:垃圾邮件)
  props: ['type', 'group'],
  setup(props) {
    const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const configId = ref('all');
    const emailList = ref([]);
    const searchCount = ref('');
    const current = ref(1);
    const size = ref(40);
    const total = ref(0);
    const tableData = ref([]);
    const loading = ref(false);
    const multipleTableRef = ref(null);
    const multipleSelection = ref([]);
    const currentMail = ref({});
    const inboxRef = ref(null);
    const tableHeight = ref(200);
    const drawer = ref(false);
    const direction = ref('rtl')
    const labelPosition = ref('top');
    const allTeamUserOptionLabel = computed(() => i18n.global.t('common.all'));
    const selectedTeamId = ref('');
    const selectedTeamSelectValue = computed({
      get() {
        return props.group && selectedTeamId.value === '' ? allTeamUserOptionLabel.value : selectedTeamId.value;
      },
      set(value) {
        selectedTeamId.value = value === allTeamUserOptionLabel.value ? '' : value;
      }
    });
    const isGroupSelectionLocked = computed(() => props.group && selectedTeamId.value === '');
    const selectedFolder = ref('all');
    const iframeContent = ref('');
    const selectedUserIdMap = ref({});
    const suppressConfigWatch = ref(false);
    const formLabelAlign = reactive({...initForm});
    const customerSearchRef = ref(null);
    const customerSearchLoading = ref(false);
    const tableDataSelect = ref([]);
    const tableRef = ref(null);
    const blackModalShow = ref(false);
    const dialogVisibleDelete = ref(false);
    const pendingDeleteRows = ref([]);
    const selectionRowMap = ref({});
    const currentPageSelectionIds = ref([]);
    const isRestoringSelection = ref(false);

    const getRowKey = (row) => String(row.id);
    const syncMultipleSelection = () => {
      multipleSelection.value = Object.values(selectionRowMap.value);
    };
    const syncSelectionState = (rows = []) => {
      const pageIds = tableData.value.map(item => getRowKey(item));
      const nextPageSelectionIds = rows.map(item => getRowKey(item));
      const nextMap = {...selectionRowMap.value};

      pageIds.forEach((id) => {
        if (currentPageSelectionIds.value.includes(id) && !nextPageSelectionIds.includes(id)) {
          delete nextMap[id];
        }
      });

      rows.forEach((row) => {
        nextMap[getRowKey(row)] = row;
      });

      selectionRowMap.value = nextMap;
      currentPageSelectionIds.value = nextPageSelectionIds;
      syncMultipleSelection();
    };
    const removeRowsFromSelection = (rows = []) => {
      if (!rows.length) {
        return;
      }
      const nextMap = {...selectionRowMap.value};
      rows.forEach((row) => {
        delete nextMap[getRowKey(row)];
      });
      selectionRowMap.value = nextMap;
      currentPageSelectionIds.value = currentPageSelectionIds.value.filter((id) => nextMap[id]);
      syncMultipleSelection();
    };
    const clearSelectionState = async () => {
      selectionRowMap.value = {};
      currentPageSelectionIds.value = [];
      multipleSelection.value = [];
      pendingDeleteRows.value = [];
      await nextTick();
      tableRef.value?.clearSelection?.();
    };
    const getActionRows = (row) => row ? [row] : multipleSelection.value;
    const restoreCurrentPageSelection = async () => {
      await nextTick();
      if (!tableRef.value) {
        return;
      }

      isRestoringSelection.value = true;
      const selectedIdSet = new Set(Object.keys(selectionRowMap.value));
      const currentSelectedIdSet = new Set(
        (tableRef.value.getSelectionRows?.() || []).map(item => getRowKey(item))
      );
      const selectedIds = [];

      tableData.value.forEach((row) => {
        const rowKey = getRowKey(row);
        const shouldSelect = selectedIdSet.has(rowKey);
        const isSelected = currentSelectedIdSet.has(rowKey);

        if (shouldSelect) {
          selectedIds.push(rowKey);
        }

        if (shouldSelect !== isSelected) {
          tableRef.value.toggleRowSelection(row, shouldSelect);
        }
      });

      currentPageSelectionIds.value = selectedIds;
      syncMultipleSelection();
      await nextTick();
      tableRef.value?.doLayout?.();
      isRestoringSelection.value = false;
    };

    // 设备标识
    const deviceFlag = computed(() => {
      return getPosType()
    })

    // 下标记录
    // const lastIdx = ref(-1);
    // // shift标识
    // const shiftFlag = ref(false);

    const MOVE_TO_ORIGINAL = 'system_original'

    // 文件夹信息
    const fileList = computed(() => route.path !== '/email/inbox' ? [{
      "id": "99999",
      "fileName": i18n.global.t('common.emailbox.receive'),
    }, ...store.state.sidebar.fileList.filter(item => item.id !== selectedFolder.value)] : store.state.sidebar.fileList.filter(item => item.id !== selectedFolder.value))

    const targetFileList = computed(() => store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value))
    const moveTargetFileList = computed(() => (route.params.folderId || route.path === '/email/foldergroup') ? [{
      "id": MOVE_TO_ORIGINAL,
      "fileName": i18n.global.t('common.move.back.original'),
      "isSystemTarget": true,
    }, ...targetFileList.value] : targetFileList.value)
    const filteredTargetFileList = computed(() => targetFileList.value.filter(item => item.id !== '99999'))
    const filteredMoveTargetFileList = computed(() => moveTargetFileList.value.filter(item => item.id !== route.params.folderId))

    // 建档信息
    const ruleForm = computed(() => store.state.customer.ruleForm);
    const form = computed(() => store.state.customer.form);
    const customerListAll = computed(() => store.state.customer.customerListAll || []);
    // 区域列表
    const areaList = computed(() => store.state.customer.areaList);
    // 客户等级
    const tableDataLevel = computed(() => store.state.cusList.tableData);
    // 对话框
    const dialogVisible = ref(false);
    // 对话框表单信息
    const forms = reactive({email: '', customerName: '', merge: true, contactName: ''})
    const teamId = computed(() => store.state.email.teamID);
    const CUSTOMER_DETAIL_ROUTE_MODE = 'enhanced';
    const CUSTOMER_DETAIL_ROUTE_BUILDERS = {
      legacy: ({customerId, customerType = 1}) => ({
        path: `/email/customer/detail/${customerId}`,
        query: {type: customerType},
      }),
      enhanced: ({customerId, customerType = 1, tabKey = 2}) => ({
        path: `/email/customer/detail/${customerId}`,
        query: {
          tabKey,
          type: customerType,
          ...(teamId.value ? {teamId: teamId.value} : {}),
        },
      }),
    };
    const buildCustomerDetailRoute = ({customerId, customerType = 1, tabKey = 2} = {}) => {
      const routeBuilder = CUSTOMER_DETAIL_ROUTE_BUILDERS[CUSTOMER_DETAIL_ROUTE_MODE]
          || CUSTOMER_DETAIL_ROUTE_BUILDERS.legacy;
      return routeBuilder({customerId, customerType, tabKey});
    };
    const options = []
    const optionsCustomers = ref([])
    //默认文件id
    const fileGroupId = computed(() => store.state.sidebar.targetFileList.length > 0 ? store.state.sidebar.targetFileList[0].id : null)


    // 语言
    const lang = computed(() => store.state.system.langLocal)
    // 对话框中的建档
    const dialogVisibleCreatedMessage = ref(false);
    // 联系人
    const contactPerson = [{
      label: i18n.global.t('common.email.existingContacts'),
      value: true
    }, {label: i18n.global.t('common.email.newContacts'), value: false}];
    // 手动筛选联系人列表
    const contactList = ref([])
    const blackModalList = computed(() => multipleSelection.value.map(item => item.from))
    const currentMailRecipientTextMap = computed(() => buildRecipientTextMap(currentMail.value?.mailRecipientVOList))
    const currentMailToText = computed(() => currentMailRecipientTextMap.value.to)
    const currentMailCcText = computed(() => currentMailRecipientTextMap.value.cc)
    const showAttachmentPanel = ref(true)
    const attachmentList = computed(() => currentMail.value?.mailExtendList || [])
    const previewableAttachmentTypes = Object.freeze([
      ...imgFormat,
      ...pdfFormat,
      ...wordFormat,
      ...excelFormat,
      ...videoFormat,
      ...audioFormat,
      ...pptFormat,
      ...textFormat
    ])


    const resetConfigSelection = async () => {
      suppressConfigWatch.value = true;
      configId.value = 'all';
      await nextTick();
      suppressConfigWatch.value = false;
    };
    const syncSelectedUserContext = async (userId, {force = false} = {}) => {
      const nextUserId = userId === undefined || userId === null ? '' : String(userId);
      const currentUserId = selectedTeamId.value === undefined || selectedTeamId.value === null ? '' : String(selectedTeamId.value);
      if (!force && nextUserId === currentUserId) {
        return;
      }
      selectedTeamId.value = nextUserId;
      current.value = 1;
      selectedFolder.value = 'all';
      await clearSelectionState();
      if (route.path === '/email/foldergroup') {
        store.commit("sidebar/setTargetFileList", []);
        await store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: nextUserId});
      }
      await getMailListConf(nextUserId);
      await getMailList();
    };
    const handleSelectUser = async (val) => {
      await syncSelectedUserContext(val === allTeamUserOptionLabel.value ? '' : val, {force: true});
    }
    const handleSelectFolder = async (val) => {
      console.log(val, 'val')
      selectedFolder.value = val;
      current.value = 1;
      await clearSelectionState();
      await getMailList();
    }


    // 边界控制归档选择
    // const customerFlag = ref(false)
    const visiblePop = ref(false)

    const moneySendGrandson = function (value) {
      setTimeout(() => {
        getMailList()
      }, 3000)
    }
    provide('moneySendGrandson', moneySendGrandson)

    const removeEmail = (index) => {
      ruleFormUsers.mailContactEmailList.splice(index, 1);
    };
    // 编辑邮件信息
    const activeItemRow = ref([])
    const emailsReturn = ref(null)
    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

    async function getEmailsReturnInstance(retryCount = 20) {
      for (let i = 0; i < retryCount; i++) {
        await nextTick()
        if (emailsReturn.value?.getAllCustomers) {
          return emailsReturn.value
        }
        await wait(50)
      }
      return null
    }

    async function handleEdit(row) {
      if (route.path === "/email/has_send") {
        activeItemRow.value = toEmailObj(row.mailRecipientList)
      } else {
        activeItemRow.value = [{email: row.from}]
      }
      dialogVisible.value = true

      const emailsReturnInstance = await getEmailsReturnInstance()
      if (!emailsReturnInstance) {
        return
      }
      await emailsReturnInstance.getAllCustomers();
    }

    //邮箱转换
    const toEmailObj = (arr) => {
      return arr.map(item => {
        return {email: item}
      })
    }

    const createdNewCustomer = async (value) => {
      dialogVisibleCreatedMessage.value = true
      store.commit('customer/setRuleForm', {
        zoneCode: "",
        customerCode: "",
        zoneAddress: "",
        customerName: "",
        setUpTime: "",
        economicNature: "",
        companyWebsite: "",
        companyAddress: "",
        phoneWayList: [],
        emailWayList: [],
        companyFax: "",
        companyRemark: "",
        customerLevel: "",
        customerType: "",
        customerTypeId: "",
        product: "",
        marketingRemark: " ",
        createBy: "",
        branchAdmin: "",
        mangerVOList: [{managerName: ''}]
      });
      await store.commit('customer/setForm', {
        phones: [{phoneNumber: "", isDefault: true}],
        emails: [{email: value, isDefault: true}],
      })
    }

    async function getMailListConf(userId = selectedTeamId.value) {
      const res = await getMailByUserId({teamId: teamId.value, userId: userId || ''});
      const list = res.result || [];
      emailList.value = list.map(item => ({label: item.username, value: item.id}));
      await resetConfigSelection();
    }

    const teamList = computed(() => store.state.email.teamList)

    const userInfo = computed(() => store.state.user.userInfo)

    const ACCOUNTS_STORAGE_KEY = 'accounts'
    const activeUserId = computed(() => {
      const fromUserInfo = userInfo.value?.id ?? userInfo.value?.userID ?? userInfo.value?.guid ?? userInfo.value?.account
      const fromAccounts = Storage.get(ACCOUNTS_STORAGE_KEY)?.currentId
      const id = fromUserInfo ?? fromAccounts
      return id === undefined || id === null ? '' : String(id)
    })


    async function getAllUserList() {
      const result = await getTeamUserListAll({teamId: teamId.value});
      if (result.code !== 200) {
        ElMessage.error(result.message)
        return ''
      }
      console.log(result.result, 'result.result')
      console.log(teamList.value, 'teamList.value')

      if (result.result && result.result.length === 0) {
        if (teamList.value.length >= 1) {
          const nextTeamId = String(teamList.value[0].id)
          store.commit('email/setCurTeamID', nextTeamId)
        } else {
          store.commit('email/setCurTeamID', '')
          //   如果查询到没有团队的详情的话那么就跳转到首页
          router.push("/dashboard")
        }
      }
      console.log(result.result, 'result.result')
      const userList = result.result || [];
      if (props.group) {
        tableDataSelect.value = userList.filter(item => String(item.userId ?? '') !== activeUserId.value);
      } else if (!route.params.folderId) {
        tableDataSelect.value = userList;
      } else {
        tableDataSelect.value = userList.filter(item => String(item.userId) === activeUserId.value)
      }
      let nextSelectedUserId = '';
      if (props.group) {
        selectedTeamId.value = '';
        selectedUserIdMap.value = tableDataSelect.value.reduce((prev, item) => {
          prev[item.id] = item.userId;
          return prev;
        }, {});
      } else if (tableDataSelect.value.length) {
        const matchedUser = tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value) || tableDataSelect.value[0];
        console.log(tableDataSelect.value, matchedUser, 'tableDataSelect.value')
        nextSelectedUserId = matchedUser?.userId === undefined || matchedUser?.userId === null ? '' : String(matchedUser.userId);
        selectedTeamId.value = nextSelectedUserId;
        selectedUserIdMap.value = tableDataSelect.value.reduce((prev, item) => {
          prev[item.id] = item.userId;
          return prev;
        }, {});
        console.log('selectedUserIdMap.value', selectedUserIdMap.value)
        console.log(emailList.value, 'emailList.value')
        // configId.value = emailList.value && emailList.value.length > 0 && emailList.value[0].value || "all"
      }
      return nextSelectedUserId;
    }

    async function handleDownload(scope) {
      const result = await requestMailAccessory({id: scope.row.id});
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      console.log(result, 'result')
      window.open(`${location.origin}/email/detail/${scope.row.id}/${JSON.stringify({
        flag: scope.row.flag ? scope.row.flag : 0,
        isExtend: scope.row.isExtend ? scope.row.isExtend : 0,
        from: scope.row.from
      })}/${props.type}`);
    }

    function getAttachmentExt(item = {}) {
      const fileName = item.name || item.fileName || '';
      const extIndex = fileName.lastIndexOf('.');
      if (extIndex === -1) {
        return '';
      }
      return fileName.substring(extIndex + 1).toLowerCase();
    }

    function canPreviewAttachment(item = {}) {
      return previewableAttachmentTypes.includes(getAttachmentExt(item));
    }

    async function handleAttachmentDownload(url, fileName) {
      try {
        if (!url) {
          ElMessage.error('文件地址无效');
          return;
        }

        const safeUrl = url.replace(/^http:\/\//i, "https://");
        const response = await fetch(safeUrl, {method: "GET"});

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        downloadFile(blob, fileName || safeUrl.split("/").pop() || "download");
      } catch (error) {
        console.error('下载失败:', error);
        ElMessage.error("下载失败，请稍后重试");
      }
    }

    const openAttachmentWindow = (url) => {
      window.open(url, "_blank");
    };

    function buildOpenUrl(path, row, extra = "") {
      if (!row || !row.url || !row.name) {
        return "";
      }
      const safeUrl = row.url.replace(/^http:\/\//i, "https://");
      const ext = getAttachmentExt(row);

      return `${location.origin}/${path}`
          + `?url=${encodeURIComponent(safeUrl)}`
          + `&type=${encodeURIComponent(ext)}`
          + extra;
    }

    const showTargetPdf = (row) => {
      openAttachmentWindow(buildOpenUrl("showfile", row));
    };

    const showTargetText = (row) => {
      openAttachmentWindow(buildOpenUrl("showtext", row));
    };

    const showTargetVideo = (row) => {
      openAttachmentWindow(buildOpenUrl("showvideo", row));
    };

    const showTargetAudio = (row) => {
      openAttachmentWindow(buildOpenUrl("showaudio", row, `&title=${encodeURIComponent(row.name)}`));
    };

    const showTargetFile = (row) => {
      const images = [];
      let initialViewIndex = 0;

      attachmentList.value
          .filter(item => imgFormat.includes(getAttachmentExt(item)))
          .forEach((item) => {
            if (item.name === row.name) {
              initialViewIndex = images.length;
            }
            images.push({src: item.url?.replace(/^http:\/\//i, "https://") || ""});
          });

      viewerApi({
        images,
        options: {
          initialViewIndex
        }
      })
    }

    function handleDetailFile(item) {
      const fileExtend = getAttachmentExt(item);

      if (imgFormat.includes(fileExtend)) {
        showTargetFile(item)
      } else if (pdfFormat.includes(fileExtend)) {
        showTargetPdf(item);
      } else if (wordFormat.includes(fileExtend) || excelFormat.includes(fileExtend) || pptFormat.includes(fileExtend)) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(item.url))
      } else if (textFormat.includes(fileExtend)) {
        showTargetText(item)
      } else if (videoFormat.includes(fileExtend)) {
        showTargetVideo(item)
      } else if (audioFormat.includes(fileExtend)) {
        showTargetAudio(item)
      } else {
        handleAttachmentDownload(item.url, item.name)
      }
    }

    const moveTargetFileVisitable = ref(false);
    const activeItem = ref([]);
    const closeMoveTarget = () => {
      moveTargetFileVisitable.value = false
      activeItem.value = []
    }
    const handleReSave = throttle((item) => {
      activeItem.value = [item]
      moveTargetFileVisitable.value = true
    }, 500)
    const refreshCurrentMailDetail = async () => {
      if (!getTargetMailId.value) {
        return;
      }
      await handleCurrentRowChange({id: getTargetMailId.value});
    }

    function handleToCustomer(scope) {
      router.push(buildCustomerDetailRoute({
        customerId: scope.row.id,
        customerType: scope.row.type ?? 1,
        tabKey: 2,
      }));
    }

    async function handleCurrentChange(page) {
      current.value = page;
      tableRef.value?.setScrollTop?.(0);
      await getMailList(sortObj.value);
    }

    //回复
    function handleReply(row) {
      sessionStore.set('reSend', row);

      const query = {
        id: row.id,
        flag: row.flag,
        isRead: row.isRead,
        mailType: props.type,
      };

      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }

      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;

      // 在新标签页打开
      window.open(url, '_blank');
    }

    //重发
    function handleResend(row) {
      sessionStore.set('reSend', row);

      const query = {
        id: row.id,
        flag: row.flag,
        type: "resend",
        mailType: props.type,
      };

      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }

      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();

      // 构造 URL 并在新标签页中打开（假设使用 history 模式）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      window.open(url, '_blank');
    }

    async function getMailList(sort) {
      let folderId = route.params.folderId || route.path === '/email/foldergroup';
      const teamIdCheck = route.query.teamID ? route.query.teamID : sessionStore.get("teamId");
      loading.value = true;
      const formParams = {...formLabelAlign};
      const selectedCustomerId = formParams.customerId;
      const selectedCustomerName = getSelectedCustomerName(selectedCustomerId);
      console.log(formParams, teamIdCheck, 'formParams')
      delete formParams.rangePickerTime;
      delete formParams.isTrack;
      delete formParams.isAnswer;
      delete formParams.isReply;
      delete formParams.customerId;
      let payload = {
        ...formParams,
        customerName: selectedCustomerName,
        ...(selectedCustomerId !== '' && selectedCustomerId !== null && selectedCustomerId !== undefined ? {customerId: selectedCustomerId} : {}),
        mailConfigId: configId.value === 'all' ? null : configId.value,
        pageNo: isSearch.value ? 1 : current.value,
        type: (props.type === 2 ? formParams.type : props.type) || 1, // `group_id` char(50) DEFAULT NULL COMMENT '邮件类型(-1:失败邮件,1:收件箱,2:草稿箱,3:已发送,4:已删除,5:垃圾邮件)',
        userId: selectedTeamId.value,
        teamId: teamIdCheck,
        search: isClear.value ? "" : searchCount.value,
        pageSize: size.value,
        stress: null,
        isAnswer: formLabelAlign.isAnswer === -1 ? "" : formLabelAlign.isAnswer,
        isTrack: formLabelAlign.isTrack === -1 ? "" : formLabelAlign.isTrack,
        isReply: formLabelAlign.isReply === -1 ? "" : formLabelAlign.isReply,
        startTime: formLabelAlign.rangePickerTime.length ? formatTime(formLabelAlign.rangePickerTime[0]) : null,
        endTime: formLabelAlign.rangePickerTime.length ? formatTime(formLabelAlign.rangePickerTime[1]) : null,
        // rangePickerTime: null,
        // orderTime: 2,
      }
      if (folderId) {
        payload = {...payload, fileGroupId: folderId}
      }
      if (route.path === '/email/foldergroup') {
        if (selectedFolder.value === "all") {
          delete payload.fileGroupId;
        } else {
          payload = {...payload, fileGroupId: selectedFolder.value}
        }
      }
      if (sort) {
        console.log(sort, 'sort')
        payload = {...payload, ...sort}
      }

      let ApiTarget = folderId ? getGroupMailList : getMail;

      if (folderId) {
        delete payload.type
      }

      const result = await ApiTarget(payload);
      if (result.code !== 200) {
        loading.value = false;
        ElMessage.error(result.message)
        return
      }
      loading.value = false;
      isSearch.value = false;
      // // console.log('列表', result);
      const {records, total: newTotal} = result.result;
      total.value = newTotal;
      tableData.value = [...records]
      current.value = result.result.current;
      await restoreCurrentPageSelection();
      console.log('接口 records === tableData.value ?', records, records === tableData.value, tableData.value)
    }

    let endIndex = -1;
    //按住shirt键
    const handleKeyDown = (event) => {
      console.log(event.key, 'event.key')
      if (event.key === 'Shift' && event.keyCode === 16) {
        // console.log("进来了-----------------", event.key, event.keyCode);
        isShiftPressed.value = true;
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === 'Shift' && event.keyCode === 16) {
        isShiftPressed.value = false;
      }
    };

    function handleSelectionChange(val) {
      if (isRestoringSelection.value) {
        currentPageSelectionIds.value = val.map(item => getRowKey(item));
        return;
      }
      // console.log("val-----------------------", val)
      //判断是否按住shirt键盘
      console.log(isShiftPressed.value);
      endIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
      const startIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
      console.log(endIndex, startIndex);
      if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
        const start = startIndex < endIndex ? startIndex : endIndex;
        const end = endIndex < startIndex ? startIndex : endIndex;
        // console.log(start, end, '===============');
        for (let i = start; i <= end; i++) {
          const row = tableData.value[i];
          if (start === i || i === end) {
            continue;
          }
          console.log(row, '更新');
          if (row) {
            tableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
          }
        }
        nextTick(() => {
          const selectedRows = tableRef.value.getSelectionRows();
          syncSelectionState(selectedRows);
          console.log(selectedRows, '当前选中行');
        });
      } else {
        //走正常逻辑
        syncSelectionState(val);
      }
    }

    async function requestTagMail(tag, type, rows = multipleSelection.value, clearAfterSuccess = false) {
      if (!rows.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const result = await tagMail({
        [type]: tag,
        mailIdList: rows.map(item => item.id),
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')

      const mailIdSet = new Set(rows.map(item => getRowKey(item)));
      const nextMap = {...selectionRowMap.value};
      rows.forEach((row) => {
        const rowKey = getRowKey(row);
        if (nextMap[rowKey]) {
          nextMap[rowKey] = {...nextMap[rowKey], [type]: tag};
        }
      });
      selectionRowMap.value = nextMap;
      syncMultipleSelection();

      tableData.value = tableData.value.map(item => {
        if (mailIdSet.has(getRowKey(item))) {
          return {...item, [type]: tag}
        }
        return item
      })

      if (clearAfterSuccess) {
        await clearSelectionState();
      }

      if (rows.length > 1) {
        await getMailList()
      }
    }

    async function requestTagAllRead() {
      // 文件夹 已读
      const payload = {
        teamId: teamId.value,
        userId: selectedTeamId.value,
        type: props.type || 1,
        mailConfigId: configId.value === 'all' ? null : configId.value,
      }
      if (route.params.folderId) {
        payload.fileGroupId = route.params.folderId
      }
      const result = await tagAllRead(payload);
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      ElMessage.success(i18n.global.t('email.list.all.isread'));
      // 更新标志
      await clearSelectionState();
      await store.dispatch('countshow/getTeamAllDataApis')
      await getMailList();
    }

    async function requestDelMail(flag, row) {
      const actionRows = getActionRows(row);

      if (!actionRows.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }

      // 构建请求参数
      const params = {
        type: flag, // 0 还原  1 已删除 2彻底删除
        mailIdList: actionRows.map(item => item.id),
      };

      // 只有 type: 1 时才需要传递 originalPosition
      if (flag === 1) {
        params.originalPosition = props.type;
      }

      if (flag === 0) {
        const result = await delMail(params);
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
        if (row) {
          removeRowsFromSelection(actionRows);
        } else {
          await clearSelectionState();
        }
        ElMessage.success(i18n.global.t('email.list.reduction'));
        setTimeout(async () => {
          await getMailList();
        }, 1500);
      }
      if (flag === 1) {
        const result = await delMail(params);
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
        if (row) {
          removeRowsFromSelection(actionRows);
        } else {
          await clearSelectionState();
        }
        ElMessage.success(i18n.global.t('sys.message.success.delete'));
        setTimeout(async () => {
          await getMailList();
        }, 1500);
      }
      if (flag === 2) {
        pendingDeleteRows.value = actionRows;
        dialogVisibleDelete.value = true;
      }
    }

    // 彻底删除提示
    const deleteLoading = ref(false)

    async function deleteAll() {
      const actionRows = pendingDeleteRows.value.length ? pendingDeleteRows.value : multipleSelection.value;
      if (!actionRows.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      deleteLoading.value = true
      // type: 2 不需要 originalPosition
      const result = await delMail({
        type: 2, // 0 还原  1 已删除 2彻底删除
        mailIdList: actionRows.map(item => item.id),
      });
      if (result.code !== 200) {
        deleteLoading.value = false
        ElMessage.error(result.message);
        return;
      }
      deleteLoading.value = false
      await clearSelectionState();
      pendingDeleteRows.value = [];
      ElMessage.success(i18n.global.t('email.list.delete'));
      dialogVisibleDelete.value = false
      setTimeout(async () => {
        await getMailList();
      }, 1500);
    }


    async function handleBlack() {
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      blackModalShow.value = true;
    }

    const detailLoading = ref(false)

    const handleCurrentRowChange = async (current) => {
      if (current) {
        getTargetMailId.value = current.id;
      }
      if (current !== null) {
        detailLoading.value = true
        try {
          const result = await getMailDetails({id: current.id});
          let content = result.result?.mailBody?.content;
          const insertionContent = `<script>
            function errorImage(img) {
                console.log(img,'img')
                img.onerror = null;
                img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
            }
        <\/script>`;
          if (!content) {
            iframeContent.value = replaceEmptyPTagsWithBr(resetCss + '')
          } else {
            if (containsHtmlTags(content)) {
              const replacedHtmlString = addImgOnErrorAttribute(content)
              console.log('content', content);
              const res = replacedHtmlString.replace(/(<html[^>]*>)/, '$1' + insertionContent);
              iframeContent.value = replaceEmptyPTagsWithBr(resetCss + res);
            } else {
              console.log("非html")
              // 纯图片需要直接展示
              if (content.indexOf('https://s3gw.cmbimg.com') !== -1) {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + content);
              } else {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + convertLinksToHTML(convertToHTML(content)));
              }
            }
          }
          console.log(iframeContent.value, 'iframeContent')
          currentMail.value = result.result;
          detailLoading.value = false
        } catch (e) {
          console.log('------------iframe----------')
          detailLoading.value = false
        }
      }
    }

    const getTargetMailId = ref(null)

    async function handleViewDetail(row) {
      console.log('双击', row);
      // if (props.type === 3) {
      //   const query = {id: row.id, flag: row.flag, type: "resend"};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else if (props.type === 2) {
      //   const query = {id: row.id, flag: row.flag, type: "editMail", fromType: props.type};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else {
      getTargetMailId.value = row.id
      //邮件已读
      // 已读的邮件 避免被重复赋值
      if (row?.isRead !== 1) {
        await requestTagMail(commandList[0], 'isRead', [row]);
      }
      window.open(`${location.origin}/email/detail/${row.id}/${JSON.stringify({
        flag: row.flag ? row.flag : 0,
        isExtend: row.isExtend ? row.isExtend : 0,
        from: row.from,
        customerId: row.customerId,
      })}/${props.type}`);

      // window.location.href = `${location.origin}/email/detail/${row.id}/${JSON.stringify({
      //     flag: row.flag ? row.flag : 0,
      //     isExtend: row.isExtend ? row.isExtend : 0,
      //     from: row.from,
      //   })}/${props.type}`;
      await getMailList();
      // }
    }

    async function handleCommand(val) {
      // // console.log(val, multipleSelection.value);
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const type = val === 0 || val === 1 ? 'isRead' : 'isStress';
      await requestTagMail(commandList[val], type, multipleSelection.value, true);
    }
    const handleBatchSetRead = () => handleCommand(0)
    const handleBatchDelete = () => requestDelMail(1, false)
    const handleDraftDelete = () => requestDelMail(1)
    const handleTrashEmpty = () => requestDelMail(2, false)
    const handleTrashRestore = () => requestDelMail(0, false)

    // 邮件分组
    async function handleGroupEmail(id) {
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const actionRows = [...multipleSelection.value];
      console.log(multipleSelection.value, 'multipleSelection.value')
      if (id === MOVE_TO_ORIGINAL) {
        const result = await delMail({
          type: 3, // 0 还原  1 已删除 2彻底删除 3.还原
          mailIdList: actionRows.map(item => item.id),
          teamId: teamId.value,
        });
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
        await clearSelectionState();
        ElMessage.success(result.message)
        await getMailList()
      } else {
        await groupEmailTarget(id, actionRows)
      }
    }

    // 邮件分组
    async function groupEmailTarget(id, rows = multipleSelection.value) {
      try {
        const payload = {
          userId: selectedTeamId.value,
          fileGroupId: id,
          mailIdList: rows.map(item => item.id),
          originalPosition: props.type * 1,
        }
        console.log(payload)
        const res = await groupEmail(payload)
        await clearSelectionState();
        ElMessage.success(res.message)
        await store.dispatch('countshow/getTeamAllDataApis')
        await getMailList()
      } catch (e) {

      }
    }

    async function handleSettingStress(scope, type) {
      // // console.log(scope.row, type);
      await requestTagMail(commandList[type], 'isStress', [scope.row]);
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
    }

    const handleSetRead = async (scope) => {
      // // console.log(scope);
      const isRead = scope.row.isRead;
      const result = await tagMail({
        isRead: isRead === 1 ? 0 : 1,
        mailIdList: [scope.row.id],
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      const rowKey = getRowKey(scope.row);
      if (selectionRowMap.value[rowKey]) {
        selectionRowMap.value = {
          ...selectionRowMap.value,
          [rowKey]: {...selectionRowMap.value[rowKey], isRead: isRead === 1 ? 0 : 1}
        };
        syncMultipleSelection();
      }
      tableData.value = tableData.value.map(item => {
        if (item.id === scope.row.id) {
          return {...item, isRead: isRead === 1 ? 0 : 1}
        } else {
          return item
        }
      })
      // tableData.value[scope.$index].isRead = isRead === 1 ? 0 : 1;
      // console.log(tableData.value, tableData.value[scope.$index], 'index')
      // if (sortObj.value?.orderRead !== null) {
      //   await getMailList()
      // }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
    }

    async function handleSearch(val) {
      // // console.log(formLabelAlign);
      ['customerName', 'subject', 'content'].forEach((field) => {
        if (typeof formLabelAlign[field] === 'string') {
          formLabelAlign[field] = formLabelAlign[field].trim();
        }
      });
      if (val === 'search') {
        isSearch.value = true
      }
      current.value = 1;
      await clearSelectionState();
      await getMailList();
      drawer.value = false;
    }

    async function filterReset() {
      formLabelAlign.customerName = initForm.customerName;
      formLabelAlign.customerId = initForm.customerId;
      formLabelAlign.customerTypeId = initForm.customerTypeId;
      formLabelAlign.isAnswer = initForm.isAnswer;
      formLabelAlign.isTrack = initForm.isTrack;
      formLabelAlign.isReply = initForm.isReply;
      formLabelAlign.rangePickerTime = initForm.rangePickerTime;
      formLabelAlign.zoneAddress = initForm.zoneAddress;
      formLabelAlign.type = 2;
      current.value = 1;
      await clearSelectionState();
      await nextTick();
      getMailList();
    }

    function tableRowClassName({row, rowIndex}) {
      return `read_${row.isRead}`;
    }

    async function handleBlackSucc() {
      blackModalShow.value = false;
      await clearSelectionState();
      setTimeout(() => {
        getMailList();
      }, 1500);
    }

    function handleBlackCancel() {
      blackModalShow.value = false;
    }

    const isClear = ref(false);
    //是否点击搜索或者高级搜索按钮,页数从1开始计算
    const isSearch = ref(false);

    const trimSearchCount = () => {
      if (typeof searchCount.value === 'string') {
        searchCount.value = searchCount.value.trim()
      }
    }

    const getSelectedCustomerName = (customerId = formLabelAlign.customerId) => {
      if (customerId === '' || customerId === null || customerId === undefined) {
        return null;
      }
      const target = customerListAll.value.find((item) => String(item.id) === String(customerId));
      return target?.customerName ?? formLabelAlign.customerName ?? null;
    };

    const syncSelectedCustomerName = (customerId = formLabelAlign.customerId) => {
      formLabelAlign.customerName = getSelectedCustomerName(customerId);
    };

    const handleCustomerSearchChange = (value) => {
      if (value === '' || value === null || value === undefined) {
        formLabelAlign.customerId = null;
        formLabelAlign.customerName = null;
        return;
      }
      formLabelAlign.customerId = value;
      syncSelectedCustomerName(value);
    };

    const handleCustomerSearchLoaded = (list) => {
      customerSearchLoading.value = false;
      if (!Array.isArray(list) || !list.length) {
        return;
      }
      if (formLabelAlign.customerId !== '' && formLabelAlign.customerId !== null && formLabelAlign.customerId !== undefined) {
        syncSelectedCustomerName(formLabelAlign.customerId);
      }
    };

    const handleCustomerSearchLoading = (val) => {
      customerSearchLoading.value = !!val;
    };

    // 打开“高级搜索”抽屉时预加载客户数据，使用户点开“公司名称”下拉时数据基本已就绪；
    // ensureLoaded 内部已做同团队去重，反复开关抽屉不会重复请求；nextTick 确保抽屉内组件已挂载
    const handleAdvancedSearchOpen = () => {
      nextTick(() => {
        customerSearchRef.value?.ensureLoaded();
      });
    };

    async function handleSearchInput(flag) {
      trimSearchCount()

      if (flag === "clear") {
        isClear.value = true
      } else if (flag === 'search') {
        isSearch.value = true
      } else {
        isClear.value = false
      }
      current.value = 1;
      await clearSelectionState();
      await getMailList();
    }

    watch(() => teamId.value, async () => {
      console.log('组件团队ID 监听', teamId.value);
      if (teamId.value) {
        formLabelAlign.customerId = initForm.customerId;
        formLabelAlign.customerName = initForm.customerName;
        current.value = 1;
        await clearSelectionState();
        const nextSelectedUserId = await getAllUserList();
        await syncSelectedUserContext(nextSelectedUserId, {force: true});
      }
      configId.value = 'all';
    })

    watch(() => configId.value, async (value, oldValue) => {
      if (suppressConfigWatch.value || value === oldValue) {
        return;
      }
      current.value = 1;
      await clearSelectionState();
      await getMailList();
    });

    const myEmailList = computed(() => store.state.countshow.myEmailList)
    watch(() => myEmailList.value, async (value) => {
      if (myEmailList.value.map((item) => item.count).reduce((acc, val) => acc + val, 0) !== value.map((item) => item.count).reduce((acc, val) => acc + val, 0)) {
        await getMailList()
      }
    }, {immediate: true})

    const getEmailListFlag = computed(() => store.state.countshow.getEmailListFlag)

    watch(() => getEmailListFlag.value, async () => {
      await getMailList();
    })

    // 页面进行缩放
    const adjustContentPosition = debouncePlus(async () => {
      await nextTick()
      syncDragBoxHeight();
      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      await nextTick()
      applyStoredVerticalPanelsHeight();
      tableRef.value?.doLayout?.()
    }, 200)

    onMounted(async () => {
      loading.value = true;
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('keyup', handleKeyUp);
      await nextTick()
      syncDragBoxHeight();
      store.commit("sidebar/setTargetFileList", [])
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: 1})
      // elementTop.value = tableHeight.value
      store.dispatch('customer/getAreaNames')
      store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      applyStoredVerticalPanelsHeight();
      await store.dispatch("sidebar/getEmailGroupFileListApis", {
        teamId: teamId.value,
        userId: props.group ? '' : activeUserId.value
      })
      const nextSelectedUserId = await getAllUserList();
      if (props.group) {
        selectedFolder.value = 'all';
      }
      await syncSelectedUserContext(nextSelectedUserId, {force: true});
      window.addEventListener('resize', adjustContentPosition);
    });

    onBeforeUnmount(() => {
      clearIframeScrollState();
      clearVerticalResizeState();
      window.removeEventListener('resize', adjustContentPosition);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    });


    const close = () => {
      dialogVisible.value = false;
    }
    const closeCreated = () => {
      dialogVisibleCreatedMessage.value = false;
    }

    // 上下拖动事件
    const minTopPanelHeight = 30;
    const minBottomPanelHeight = 0;
    const verticalPanelGap = 0;
    const verticalResizeBarHeight = 30;
    const topBoxValue = ref(null);
    const downBoxValue = ref(null)
    // 上下区域拖动调整
    const moveTarget = ref(null);
    const scrollBox = ref(null);
    const pageframe = ref(null);
    const isDragging = ref(false);
    const initialMouseY = ref(0)
    const elementLeft = ref(0)
    const DragBox = ref()
    const dragBoxHeight = ref(0)
    let verticalResizeFrame = null;
    let removeVerticalResizeListeners = null;
    let removeIframeScrollListeners = null;
    let iframeWheelFallbackFrame = null;
    const getMaxTopPanelHeight = () => Math.max(dragBoxHeight.value - minBottomPanelHeight - verticalPanelGap, minTopPanelHeight)
    const getClampedTopPanelHeight = (height) => {
      const safeHeight = Number.isFinite(height) ? height : minTopPanelHeight;
      return Math.min(Math.max(safeHeight, minTopPanelHeight), getMaxTopPanelHeight());
    }
    const getStoredInboxLayoutTop = () => {
      const storedTop = Number(store.state.system.inboxTop);
      if (Number.isFinite(storedTop) && storedTop > 0) {
        return storedTop;
      }

      const storedBottomHeight = Number(store.state.system.inboxHeight);
      if (dragBoxHeight.value && Number.isFinite(storedBottomHeight) && storedBottomHeight >= 0) {
        return dragBoxHeight.value - storedBottomHeight - verticalPanelGap;
      }

      return minTopPanelHeight;
    }
    const syncVerticalPanelsHeight = (nextTopHeight) => {
      if (!dragBoxHeight.value) return;
      const fallbackTopHeight = Number.isFinite(topBoxValue.value) ? topBoxValue.value : getStoredInboxLayoutTop();
      const topHeight = getClampedTopPanelHeight(nextTopHeight ?? fallbackTopHeight);
      topBoxValue.value = topHeight;
      downBoxValue.value = Math.max(dragBoxHeight.value - topHeight - verticalPanelGap, minBottomPanelHeight);
      elementTopRaw.value = topHeight;
      pageframeHeightRaw.value = downBoxValue.value;
    }
    const applyStoredVerticalPanelsHeight = () => {
      if (!dragBoxHeight.value) return;
      syncVerticalPanelsHeight(getStoredInboxLayoutTop());
    }
    const syncDragBoxHeight = () => {
      if (!DragBox.value) return;
      dragBoxHeight.value = Math.max(DragBox.value.offsetHeight - verticalResizeBarHeight, 0);
      syncVerticalPanelsHeight();
    }
    const topPanelHeight = computed(() => Number.isFinite(topBoxValue.value) ? topBoxValue.value : getClampedTopPanelHeight(store.state.system.inboxTop || minTopPanelHeight))
    const downPanelHeight = computed(() => {
      if (Number.isFinite(downBoxValue.value)) return downBoxValue.value;
      if (!dragBoxHeight.value) return Math.max(store.state.system.inboxHeight || minBottomPanelHeight, minBottomPanelHeight);
      return Math.max(dragBoxHeight.value - topPanelHeight.value - verticalPanelGap, minBottomPanelHeight);
    })
    const inboxTop = computed(() => topPanelHeight.value)
    const inboxHeight = computed(() => downPanelHeight.value)
    const elementTopRaw = ref(inboxTop.value);
    const elementTop = computed({
      get() {
        return elementTopRaw.value;
      },
      set(newValue) {
        elementTopRaw.value = newValue;
      },
    });

    const pageframeHeightRaw = ref(deviceFlag.value === 'mac' ? inboxHeight.value : inboxHeight.value + inboxHeight.value * 0.4);
    const pageframeHeight = computed({
      get() {
        return pageframeHeightRaw.value;
      },
      set(newValue) {
        pageframeHeightRaw.value = newValue;
      },
    });


    const saveTargetHeight = debouncePlus((userId, pageframeHeight, elementTop) => {
      store.dispatch("system/settingTargetHeight", {
        userId,
        inboxHeight: pageframeHeight,
        inboxTop: elementTop
      });
    }, 200); // 300ms 防抖延迟

    const sortObj = ref({})

    function sort_change({column, prop, order}) {
      console.log('ffff', column, prop, order)
      if (order != null) {
        const flag = order === 'descending' ? 2 : 1;
        // 映射排序字段到相应的请求参数
        const sortMapping = {
          isStress: 'orderStress',
          isRead: 'orderRead',
          fj: 'orderExtend',
          sendTime: 'orderTime',
          contentSize: 'orderSize'
        };

        // 获取相应的请求参数
        const requestParam = sortMapping[prop];
        sortObj.value = {[requestParam]: flag};
        console.log(sortObj.value, 'sortObj')
        if (requestParam) {
          getMailList({[requestParam]: flag});
        }
      } else {
        getMailList()
      }
    }

    // 表格内容
    const rowClassName = ({columnIndex}) => {
      return cellLeftColumnsMap[props.type]?.includes(columnIndex) ? cellAlignLeftStyle : cellAlignCenterStyle
    }

    // 表头
    const headerClassName = ({columnIndex}) => {
      return headerLeftColumnsMap[props.type]?.includes(columnIndex) ? headerAlignLeftStyle : headerAlignCenterStyle
    }


    const refMap = ref([])
    const tempRef = ref(null)
    const visiblePopover = ref(false)
    const popoverType = ref(0)
    const emailListCheckoutTarget = ref({remark: ''})
    const handleRef = debouncePlus((ref, item, type) => {
      tempRef.value = ref
      popoverType.value = type
      visiblePopover.value = true;
      emailListCheckoutTarget.value = item;
    }, POPOVER_DELAY_TIME)

    const hidePopoverTimeoutModel = ref(false)
    // 这里是开始点
    const mouseEnters = debouncePlus((row) => {
      // 特殊处理 不然第一次 修改后 后续触发有问题
      popoverType.value = 0
      emailListCheckoutTarget.value = row;
    }, 200)

    const mouseLeaves = () => {
      hidePopoverTimeoutModel.value = setTimeout(() => {
        visiblePopover.value = false;
      }, 300);
    }
    const keepPopoverVisibleModel = () => {
      if (hidePopoverTimeoutModel.value) {
        clearTimeout(hidePopoverTimeoutModel.value);
        hidePopoverTimeoutModel.value = null;
      }
      visiblePopover.value = true;
    }

    const hidePopoverModel = () => {
      visiblePopover.value = false;
    }

    const cancelPopover = () => {
      visiblePopover.value = false;
      emailListCheckoutTarget.value.remark = ''
    }

    // 搜索条件重制
    const resetSearchFlags = () => {
      isClear.value = true;
      searchCount.value = "";
      configId.value = "all"
    }

    const handleEditMail = (row) => {
      const query = {
        id: row.id,
        flag: row.flag,
        type: "editMail",
        mailType: props.type,
      };
      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }
      router.push({
        path: '/email/write_mail',
        query,
      });
    }


    const computedTargetWidth = computed(() => {
      if (props.type === 1 || props.type === 3) {
        return lang.value === 'en' ? 3 * 60 : 3 * 50;
      } else if (props.type === 2) {
        return lang.value === 'en' ? 1 * 90 : 2 * 50;
      } else if (props.type === 4) {
        return lang.value === 'en' ? 2 * 60 : 2 * 50;
      }
    })


    const visibleTo = ref(false)
    const visibleCC = ref(false)

    const hidePopoverTimeout = ref(false)

    function showPopover(string = '', flag) {
      if (moveTarget.value) {
        const itemWidth = Math.round((moveTarget.value.clientWidth - 40) * (1 / 3))
        const stringWidth = string.pxWidth('normal 12px PingFangSC, PingFang SC')
        console.log(itemWidth, stringWidth)
        if (stringWidth + 10 > itemWidth) {
          if (flag === "to") {
            visibleCC.value = false;
            visibleTo.value = true;
          } else if (flag === "cc") {
            visibleTo.value = false;
            visibleCC.value = true;
          }
          if (hidePopoverTimeout.value) {
            clearTimeout(hidePopoverTimeout.value);
            hidePopoverTimeout.value = null;
          }
        }
      }
    }

    function delayedHidePopover(flag) {
      hidePopoverTimeout.value = setTimeout(() => {
        flag === "to" ? visibleTo.value = false : visibleCC.value = false;
      }, 200); // Adjust delay as necessary
    }

    function keepPopoverVisible(flag) {
      if (hidePopoverTimeout.value) {
        clearTimeout(hidePopoverTimeout.value);
        hidePopoverTimeout.value = null;
      }
      flag === "to" ? visibleTo.value = true : visibleCC.value = true;
    }

    function hidePopover(flag) {
      flag === "to" ? visibleTo.value = false : visibleCC.value = false;
    }

    // 弹窗进行编辑备注
    const visitableRemark = ref(false)
    const currentItem = ref({remark: ""})
    const handleClickRemark = (row) => {
      const {id} = row
      console.log(id, row, 'id')
      currentItem.value = row
      visitableRemark.value = true
    }
    const closeRemark = () => {
      visitableRemark.value = false
    }
    const handleDeleteDialogVisibleUpdate = (val) => {
      dialogVisibleDelete.value = val
      if (!val) {
        pendingDeleteRows.value = []
      }
    }
    const handleDeleteCancel = () => {
      dialogVisibleDelete.value = false
      pendingDeleteRows.value = []
    }

    function updateVerticalPanelsHeight(moveLen, containerHeight) {
      dragBoxHeight.value = containerHeight;
      syncVerticalPanelsHeight(moveLen);
      saveTargetHeight(activeUserId.value, downBoxValue.value, topBoxValue.value);
    }

    function clearIframeScrollState() {
      if (iframeWheelFallbackFrame) {
        cancelAnimationFrame(iframeWheelFallbackFrame);
        iframeWheelFallbackFrame = null;
      }
      if (removeIframeScrollListeners) {
        removeIframeScrollListeners();
        removeIframeScrollListeners = null;
      }
    }

    function emitIframeScrollEvent() {
      const iframeEl = pageframe.value;
      const iframeDoc = iframeEl?.contentDocument;
      if (!iframeEl || !iframeDoc) {
        return;
      }
      const scrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
      if (!scrollTarget) {
        return;
      }
      iframeEl.dispatchEvent(new Event('scroll'));
      iframeEl.dispatchEvent(new CustomEvent('iframe-scroll', {
        detail: {
          scrollTop: scrollTarget.scrollTop || 0,
          scrollLeft: scrollTarget.scrollLeft || 0,
          clientHeight: scrollTarget.clientHeight || 0,
          scrollHeight: scrollTarget.scrollHeight || 0,
        }
      }));
    }

    function bindIframeScrollListeners() {
      clearIframeScrollState();
      nextTick(() => {
        const iframeEl = pageframe.value;
        const iframeWin = iframeEl?.contentWindow;
        const iframeDoc = iframeEl?.contentDocument;
        if (!iframeEl || !iframeWin || !iframeDoc) {
          return;
        }

        const onIframeScroll = () => {
          if (isDragging.value) {
            return;
          }
          emitIframeScrollEvent();
        };
        const onIframeWheel = (event) => {
          const scrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
          const beforeScrollTop = scrollTarget?.scrollTop || 0;
          const deltaY = event.deltaY || 0;
          if (isDragging.value || !scrollTarget || !deltaY) {
            return;
          }
          if (iframeWheelFallbackFrame) {
            cancelAnimationFrame(iframeWheelFallbackFrame);
          }
          iframeWheelFallbackFrame = requestAnimationFrame(() => {
            const activeScrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
            if (!activeScrollTarget || activeScrollTarget.scrollHeight <= activeScrollTarget.clientHeight) {
              iframeWheelFallbackFrame = null;
              return;
            }
            if (activeScrollTarget.scrollTop === beforeScrollTop) {
              const maxScrollTop = Math.max(activeScrollTarget.scrollHeight - activeScrollTarget.clientHeight, 0);
              const nextScrollTop = Math.min(Math.max(beforeScrollTop + deltaY, 0), maxScrollTop);
              if (nextScrollTop !== beforeScrollTop) {
                activeScrollTarget.scrollTop = nextScrollTop;
                emitIframeScrollEvent();
              }
            }
            iframeWheelFallbackFrame = null;
          });
        };
        const passiveOptions = {passive: true};

        iframeWin.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.documentElement?.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.body?.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeWin.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.documentElement?.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.body?.addEventListener('wheel', onIframeWheel, passiveOptions);
        // 邮件正文中的链接/按钮点击后在新标签页打开对应地址
        const removeIframeLinkListener = bindIframeLinkClickToNewTab(iframeDoc, {
          shouldIgnore: () => isDragging.value,
        });

        removeIframeScrollListeners = () => {
          iframeWin.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.documentElement?.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.body?.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeWin.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.documentElement?.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.body?.removeEventListener('wheel', onIframeWheel, passiveOptions);
          removeIframeLinkListener?.();
        };

        requestAnimationFrame(() => {
          emitIframeScrollEvent();
        });
      });
    }

    function handleIframeLoad() {
      bindIframeScrollListeners();
    }

    function clearVerticalResizeState() {
      isDragging.value = false
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      if (verticalResizeFrame) {
        cancelAnimationFrame(verticalResizeFrame);
        verticalResizeFrame = null;
      }
      if (removeVerticalResizeListeners) {
        removeVerticalResizeListeners();
        removeVerticalResizeListeners = null;
      }
    }

    function handleVerticalResizeStart(e) {
      syncDragBoxHeight();
      const containerHeight = dragBoxHeight.value;
      if (!containerHeight) return false;
      const startY = e.clientY;
      const startTop = topPanelHeight.value;
      const pointerTarget = e.currentTarget;
      const pointerId = e.pointerId;

      isDragging.value = true
      document.body.style.cursor = "row-resize";
      document.body.style.userSelect = "none";
      if (pointerTarget && Number.isFinite(pointerId)) {
        try {
          pointerTarget.setPointerCapture(pointerId);
        } catch (error) {
          console.warn('setPointerCapture failed', error);
        }
      }

      const handleMouseUp = () => {
        if (pointerTarget && Number.isFinite(pointerId)) {
          try {
            pointerTarget.releasePointerCapture(pointerId);
          } catch (error) {
            console.warn('releasePointerCapture failed', error);
          }
        }
        clearVerticalResizeState();
        saveTargetHeight(activeUserId.value, downPanelHeight.value, topPanelHeight.value);
        tableRef.value?.doLayout?.();
        requestAnimationFrame(() => {
          bindIframeScrollListeners();
        });
      };
      const handleVisibilityChange = () => {
        if (document.visibilityState !== 'visible') {
          handleMouseUp();
        }
      };
      const handleMouseMove = (moveEvent) => {
        // 某些情况下 mouseup 会丢失，导致 iframe 一直处于不可交互状态。
        // 当检测到鼠标左键已经释放时，主动结束拖拽。
        if (moveEvent.buttons === 0) {
          handleMouseUp();
          return;
        }
        const deltaY = moveEvent.clientY - startY;
        const moveLen = startTop + deltaY;
        if (verticalResizeFrame) {
          cancelAnimationFrame(verticalResizeFrame);
        }
        verticalResizeFrame = requestAnimationFrame(() => {
          updateVerticalPanelsHeight(moveLen, containerHeight);
          verticalResizeFrame = null;
        });
      };
      removeVerticalResizeListeners = () => {
        window.removeEventListener('pointermove', handleMouseMove);
        window.removeEventListener('pointerup', handleMouseUp);
        window.removeEventListener('pointercancel', handleMouseUp);
        window.removeEventListener('blur', handleMouseUp);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
      window.addEventListener('pointermove', handleMouseMove);
      window.addEventListener('pointerup', handleMouseUp);
      window.addEventListener('pointercancel', handleMouseUp);
      window.addEventListener('blur', handleMouseUp);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      return false;
    }

    // 文件夹list scroll
    const pageSetting = computed(() => store.state.sidebar.pageSetting)
    const hasMoreData = computed(() => store.getters["sidebar/hasMoreData"])
    const isLoading = ref(false)
    const handleScroll = throttle((event) => {
      const bottom = event.target.scrollHeight + 300 > event.target.scrollTop + event.target.clientHeight;
      console.log(bottom, !isLoading.value, hasMoreData.value, 'bottom && !isLoading.value && hasMoreData.value')
      if (bottom && !isLoading.value && hasMoreData.value) {
        loadMore();
      }
    }, 100)
    const loadMore = async () => {
      isLoading.value = true;
      const currentPage = Number(pageSetting.value.pageNo || 0)
      const totalPages = Number(pageSetting.value.pages || 0)
      const targetPage = currentPage + 1
      if (Number.isFinite(totalPages) && totalPages > 0 && targetPage > totalPages) {
        isLoading.value = false
        return
      }
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: targetPage})
      await store.dispatch("sidebar/getEmailGroupFileListApis", {
        teamId: teamId.value,
        userId: userInfo.value.id,
        isUpdateFileList: true
      })
      isLoading.value = false; // 加载完成
    }

    function handleReplyDetail(stringType = '', row) {
      if (!row.id) {
        return;
      }
      const query = {
        id: row.id,
        type: stringType,
        mailType: props.type,
        customerId: row.customerId
      }
      if (stringType === "") {
        delete query.type;
      }
      console.log(query, 'payload')
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();
      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      // 在新标签页打开
      window.open(url, '_blank');
    }


    const openNewWindow = (url) => {
      window.open(url, "_blank");
    };

    const handleClickToLinkCustomerDetail = (customerId, customerType = 1) => {
      const customerDetailRoute = buildCustomerDetailRoute({
        customerId,
        customerType,
        tabKey: 2,
      });
      const {href} = router.resolve(customerDetailRoute);
      openNewWindow(href)
    }

    const showLogError = ref('')
    // const logErrorLoading = ref('')
    const handleShowPopover = async (item) => {
      console.log(item, 'item')
      try {
        const payload = {
          mailId: item.id
        }
        // logErrorLoading.value = i18n.global.t('common.loading.list')
        const res = await getEmailLog(payload)
        showLogError.value = res.result?.failTranslate
        // logErrorLoading.value = ''
      } catch (e) {
        // logErrorLoading.value = ''
      }
    }

    return {
      showLogError,
      handleShowPopover,
      handleClickToLinkCustomerDetail,
      openNewWindow,
      refreshCurrentMailDetail,
      closeMoveTarget,
      moveTargetFileVisitable,
      activeItem,
      handleReSave,
      handleDetailFile,
      handleAttachmentDownload,
      canPreviewAttachment,
      getAttachmentExt,
      showAttachmentPanel,
      attachmentList,
      deleteLoading,
      handleReplyDetail,
      DragBox,
      isLoading,
      loadMore,
      handleScroll,
      topBoxValue,
      topPanelHeight,
      downBoxValue,
      downPanelHeight,
      currentItem,
      closeRemark,
      visitableRemark,
      handleClickRemark,
      handleDeleteDialogVisibleUpdate,
      handleDeleteCancel,
      handleVerticalResizeStart,
      selectedFolder,
      isGroupSelectionLocked,
      filteredTargetFileList,
      filteredMoveTargetFileList,
      props,
      handleGroupEmail,
      fileList,
      hidePopoverModel,
      keepPopoverVisibleModel,
      showPopover,
      delayedHidePopover, keepPopoverVisible, hidePopover,
      visibleTo,
      visibleCC,
      lang,
      computedTargetWidth,
      handleEditMail,
      popoverType,
      refMap,
      tempRef,
      detailLoading,
      handleIframeLoad,
      cancelPopover,
      mouseLeaves,
      mouseEnters,
      emailListCheckoutTarget,
      visiblePopover,
      handleRef,
      visiblePop,
      handleResend,
      headerClassName,
      rowClassName,
      sort_change,
      getMailList,
      createdNewCustomer,
      emailsReturn,
      activeItemRow,
      close,
      closeCreated,
      deleteAll,
      pageframeHeight,
      elementLeft,
      elementTop,
      scrollBox,
      pageframe,
      moveTarget,
      configId,
      emailList,
      tableData,
      current,
      size,
      total,
      loading,
      multipleTableRef,
      inboxRef,
      tableHeight,
      tableRef,
      drawer,
      direction,
      labelPosition,
      formLabelAlign,
      tableDataLevel,
      areaList,
      iframeContent,
      tableDataSelect,
      allTeamUserOptionLabel,
      selectedTeamId,
      selectedTeamSelectValue,
      blackModalShow,
      multipleSelection,
      searchCount,
      handleCommand,
      handleBatchSetRead,
      handleBatchDelete,
      handleDraftDelete,
      handleTrashEmpty,
      handleTrashRestore,
      currentMail,
      currentMailToText,
      currentMailCcText,
      tableRowClassName,
      handleViewDetail,
      handleReply,
      handleSetRead,
      handleSearch,
      handleSearchInput,
      filterReset,
      handleDownload,
      handleCurrentChange,
      handleCurrentRowChange,
      handleSettingStress,
      handleSelectionChange,
      requestTagAllRead,
      requestDelMail,
      customerSearchRef,
      customerSearchLoading,
      handleCustomerSearchChange,
      handleCustomerSearchLoaded,
      handleCustomerSearchLoading,
      handleAdvancedSearchOpen,
      handleBlack,
      handleEdit,
      handleBlackSucc,
      handleBlackCancel,
      dialogVisible,
      dialogVisibleCreatedMessage,
      forms,
      options,
      optionsCustomers,
      contactPerson,
      contactList,
      removeEmail,
      ruleForm,
      form,
      dialogVisibleDelete,
      blackModalList,
      emptyUrl,
      route,
      handleSelectUser,
      handleSelectFolder,
      tableRowStyle,
      targetFileList,
      moveTargetFileList,
      isDragging,
      inboxHeight,
      inboxTop,
      pageframeHeightRaw,
      elementTopRaw,
      deviceFlag,
    }
  }
}
</script>


<style lang="less">
.el_modal {
  .el-drawer__header {
    margin-bottom: 0px;
    //padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
  }
}
</style>
<style lang="less" scoped>
@import "../../Customer/less/detail.less";
@import "./index.less";

.up_row, .down_row {
  width: 100%;
  height: 2px !important;
  cursor: row-resize !important;
}

.flex {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center
}

.over_text {
  color: black !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 26px;
  width: 33.33%;
  text-align: left;
}

.mail_info {
  user-select: text;
}

.mail_info :deep(span),
.mail_info :deep(div) {
  user-select: text;
}

#pageframe {
  background: transparent;
}

iframe {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

iframe.loaded {
  opacity: 1;
}

:deep(.el-popper) {
  max-width: 45% !important;
}

.el-popover.el-popper.visible {
  max-width: 300px !important;
}

.el-popover.el-popper.sp_model_popover {
  max-width: 300px !important;
}

.visible {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 8px !important;
  }
}

.sp_model_popover {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 12px !important;
  }
}

#sp_tables {
  position: relative;

  :deep(.el-table__header) {
    width: 100% !important;
  }

  :deep(.el-table__body) {
    width: 100% !important;
  }
}

:deep(.el-scrollbar__bar.is-horizontal) {
  height: 6px !important;
}

:deep(.el-table__inner-wrapper:before) {
  background: transparent !important;
}

:deep(.sp_email .el-input__wrapper) {
  background: #f5f7fa !important;
}

:deep(.el-input__wrapper) {
  min-height: 0px !important;
}

.Drag2 {
  height: calc(100vh - 146px);
}

/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  margin: 0.1% 0px;
  overflow: hidden;
  box-shadow: -1px 9px 10px 3px rgba(0, 0, 0, 0.11);
}

/*左侧div样式*/
.left {
  width: calc(32% - 10px); /*左侧初始化宽度*/
  height: 100%;
  background: #71ad88;
  float: left;
}

/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: -10px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
}

/*拖拽区鼠标悬停样式*/
//.movers:hover {
//  color: #444444;
//}

/*右侧div'样式*/
.mid {
  float: left;
  width: 100%; /*右侧初始化宽度*/
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11);
  /*上方div'样式*/

  .topBox {
    flex: 0 0 auto;
    min-height: 0;
    background-color: #3ff53f;
    display: flex;
  }

  /*下方div'样式*/

  .downBox {
    flex: 0 0 auto;
    min-height: 0;
    background-color: white;
    display: flex;
    overflow: hidden;
  }

  /* 拖拽区div样式 */

  .mover {
    flex: 0 0 30px;
    padding: 0px 20px;
    cursor: row-resize;
    width: 100%;
    height: 30px;
    background-color: #d6d6d6;
    border-radius: 5px;
    text-align: center;
    line-height: 3px;
    font-size: 13px;
    transition: background-color 0.2s ease;
  }

  /*拖拽区鼠标悬停样式*/

  .mover:hover {
    background-color: #cfcfcf;
    color: #444444;
  }
}

:deep(.el-checkbox__inner::after) {
  top: 1px !important;
  left: 4px !important;
}

//
.move-select {
  .dropdown-menu-wrapper {
    min-width: auto !important;
    width: auto;
    max-width: 200px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  :deep(.el-dropdown-menu__item) {
    min-width: auto !important;
    width: auto;
    max-width: 200px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inherit !important;
  }
}

.customer-level .el-select-dropdown__item {
  max-width: 100% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inner_select {
  width: auto;
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

:deep(.el-drawer__header) {
  padding-bottom: 10px !important;
}

.mail-preview-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}

.mail-preview-frame {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
}

.attachment-panel {
  width: 250px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-shrink: 0;
  font-size: 13px;
}

.attachment-panel-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0 0;
}

.file {
  display: flex;
  flex-direction: column;
  padding: 8px;
  margin: 0 8px 8px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

.attachment-item-main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.attachment-item-main .name {
  margin-left: 8px;
  color: #40a9ff;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  min-width: 0;
  flex: 1 1 auto;
}

.attachment-item-meta {
  margin-top: 4px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}

.attachment-item-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.attachment-item-actions :deep(.el-button) {
  font-size: 13px !important;
}

.file-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: 16px 12px;
  color: #909399;
  font-size: 13px;
  text-align: center;
}

:deep(.file-empty .el-empty) {
  padding: 0;
}

:deep(.file-empty .el-empty__description) {
  display: none;
}

.inners_warning {
  display: flex;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
}

.setting_center {
  display: flex !important;
  justify-content: center !important;
}

:deep(.el-select--small .el-select__wrapper) {
  font-size: 13px !important;
}

:deep(.el-input__inner) {
  font-size: 13px !important;
}

.tooltip-content-wrap {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  padding: 4px;
}

.urgent-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

.tooltip-content-wrap {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  padding: 4px;
}

:deep(.el-drawer__header){
  color:rgba(0, 0, 0, 0.85) !important;
}
</style>
